import ViewCase from './ViewCase';

export default ViewCase;
